/*global App, NProgress */

var showNProgress = true;
var piwikEnabled, piwikId, piwikVariables;

var bootstrap = function() {
    var init = function() {
        if (document.body.attributes.ajax) {
            kenaz.ajax.extScrollTop = false;
            kenaz.ajax.on("start", function() {
                let popforms = document.querySelectorAll("app-energy-table-popform");
                for (let i = 0; i < popforms.length; i++) {
                    popforms[i].toggled = false;
                }
                if (showNProgress) NProgress.start();
                else showNProgress = true;
            });
            kenaz.ajax.on("success", function() {
                if (piwikEnabled) kenaz.piwik.send();
            });
            kenaz.ajax.on("complete", function() {
                setTimeout(function() {
                    run();
                    NProgress.done();
                    showNProgress = true;
                }, 250);
            });
            tracyAjaxInit();
            kenaz.ajax.init();
        }
        if (piwikEnabled) {
            kenaz.piwik.siteId = piwikId;
            kenaz.piwik.variables = piwikVariables;
            kenaz.piwik.init();
        }
        App.Plugins.init();
        App.Ui.init();
        run();
    };

    var run = function() {
        App.Plugins.run();
        App.Ui.run();
        App.Ui.sidebarInit();
        if (document.body.attributes.ajax) {
            for (var e in _ajaxbefore) {
                kenaz.ajax.on("before", _ajaxbefore[e]);
            }
            for (var e in _ajaxsuccess) {
                kenaz.ajax.on("success", _ajaxsuccess[e]);
            }
            for (var e in _ajaxcomplete) {
                kenaz.ajax.on("complete", _ajaxcomplete[e]);
            }
        }
    };

    var tracyAjaxInit = function() {
        let ajaxTracy = new AjaxTracy();
        let oldOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function() {
            this.addEventListener("load", function() {
                ajaxTracy.handleRequest(this);
            });
            oldOpen.apply(this, arguments);
        };
    };

    init();
};

let find = function(selector, container) {
    container = container || document;
    let results = Array.prototype.slice.call(container.querySelectorAll(selector));
    let components = [];
    let componentsSearch = container.querySelectorAll("*");
    for (let i in componentsSearch) {
        let component = componentsSearch[i];
        if (component.nodeName && component.nodeName.indexOf("-") !== -1) components.push(component);
    }
    for (let i in components) {
        let component = componentsSearch[i];
        if (!component.shadowRoot) continue;
        let recursiveFind = find(selector, component.shadowRoot);
        for (let e in recursiveFind) {
            let element = recursiveFind[e];
            results.push(element);
        }
    }
    return results;
};

let Page = {
    isLoaded: false,
    setLoaded: function () {
        this.isLoaded = true;
        let el = document.createElement("span");
        el.id = "page-loaded";
        document.body.appendChild(el);
    },
};

document.addEventListener("DOMContentLoaded", function () {
    Page.setLoaded();
});
